import * as React from 'react';
import { ReportRecipientProject } from './models';
import SearchableDataModelList from '../layout/SearchableDataModelList';
import { Map } from '../language/models';


type Props = {
  className?: string;
  projects: ReportRecipientProject[];
  checkedProjects: Map<ReportRecipientProject>;
  isChecked: (displayName: string) => boolean;
  toggleCheck: (displayName: string) => void;
}

/**
 * ReportRecipientProjectList: a component that renders a searchable list of report recipient projects.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ReportRecipientProjectList: React.FC<Props> = props => {
  const projectViewData = React.useMemo(
    () => props.projects.map(project => ({ key: project.displayName, displayValue: project.displayName })),
    [props.projects],
  );

  return (
    <SearchableDataModelList
      dataValues={projectViewData}
      isChecked={props.isChecked}
      toggleChecked={props.toggleCheck}
      isProject={true}
    />
  );
};

export default ReportRecipientProjectList;
